import Work1 from "../../assets/work-1.png";
import Work2 from "../../assets/work-2.png";
import Work3 from "../../assets/work-3.png";
import Work4 from "../../assets/work-4.png";

const Menu = [
  {
    id: 1,
    image: Work1,
    title: "Inventory Pilot",
    category: "Web App",
    link: "https://inventory-pilot-one.vercel.app/",
  },
  {
    id: 2,
    image: Work2,
    title: "PokerU",
    category: "Mobile App",
    link: "https://apps.apple.com/us/app/pokeru-level-up-college-poker/id6741375931?platform=iphone",
  },
  {
    id: 3,
    image: Work3,
    title: "AuthZ Pro",
    category: "Web App",
    link: "https://authz-pro-app.vercel.app/",
  },
  {
    id: 4,
    image: Work4,
    title: "TaskHub",
    category: "Web App",
    link: "https://taskhub-app.onrender.com/",
  },
];

export default Menu